export default "__VITE_ASSET__ca5edbe5__"